import { analytics } from '@eti/utils';
import { SERVICE_PACKAGE_REQUEST } from '@eti/products/dist/products';
import type { BundleOptions, Option } from './models';
import { PRODUCT_CATEGORIES } from './constants/productCategories';

const getProductIndex = () => {
  const { dataLayer } = window;
  if (!dataLayer) {
    return 0;
  }
  return dataLayer.filter((item) => item.event === 'view_item')?.length ?? 0;
};
const entryExistsInDataLayer = (itemId: number) => {
  const { dataLayer } = window;
  if (!dataLayer) {
    return false;
  }
  return dataLayer.some(
    (dataLayerEvent) =>
      dataLayerEvent.event === 'view_item' && dataLayerEvent?.ecommerce?.item_id === itemId,
  );
};
const pushEventToDataLayer = (itemId: number, itemName: string) => {
  const itemCategory =
    itemId === SERVICE_PACKAGE_REQUEST.id
      ? PRODUCT_CATEGORIES.SERVICE_CC
      : PRODUCT_CATEGORIES.EXTRA;

  const viewItemEvent = {
    event: 'view_item',
    ecommerce: {
      items: [
        {
          index: getProductIndex(),
          item_category: itemCategory,
          item_id: itemId,
          item_name: itemName,
        },
      ],
    },
  };
  if (!entryExistsInDataLayer(itemId)) {
    analytics.pushEntryToDataLayer({ ecommerce: null });
    analytics.pushEntryToDataLayer(viewItemEvent, false);
  }
};
const pushBundleProductsToDatalayer = (options: BundleOptions) => {
  options.forEach((option: Option) => {
    pushEventToDataLayer(option.id, option.title);
  });
};

export const pushViewItemToDataLayer = (code: string, id: number, options?: BundleOptions) => {
  const isBundle = code === 'ANCILLARY_BUNDLE';
  if (isBundle && options && options.length > 0) {
    pushBundleProductsToDatalayer(options);
  } else {
    pushEventToDataLayer(id, code);
  }
};
